// Community File URL Management APIs

/**
 * @function ApiClient#GetFileUrl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fileName
 */
export function GetFileUrl(cid, fileName) {
  return `${this._url}/community/${cid}/file?f=${fileName}`;
}

/**
 * @function ApiClient#GetPointXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetPointXlsFileUrl(cid) {
  return `${this._url}/community/${cid}/point_export`;
}

/**
 * @function ApiClient#GetVendorXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetVendorXlsFileUrl(cid) {
  return `${this._url}/community/${cid}/vendor/export`;
}

/**
 * @function ApiClient#GetParkingXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetParkingXlsFileUrl(cid) {
  return `${this._url}/community/${cid}/parking/export`;
}

/**
 * @function ApiClient#GetInternalPeopleXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetInternalPeopleXlsFileUrl(cid) {
  return `${this._url}/community/${cid}/internal_people/export`;
}

/**
 * @function ApiClient#GetCommissionerXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetCommissionerXlsFileUrl(cid) {
  return `${this._url}/community/${cid}/commissioner/export`;
}

/**
 * @function ApiClient#GetShiftXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} month
 */
export function GetShiftXlsFileUrl(cid, month) {
  return `${this._url}/community/${cid}/shift/export?m=${month}`;
}

/**
 * @function ApiClient#getRecordXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} start
 * @param {any} end
 */
export function getRecordXlsFileUrl(cid, start, end) {
  return `${this._url}/community/${cid}/attendance_records/export?s=${start}&e=${end}`;
}

/**
 * @function ApiClient#GetHouseholdCertificateXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetHouseholdCertificateXlsFileUrl(cid) {
  return `${this._url}/community/${cid}/household_certificate/export`;
}

/**
 * @function ApiClient#GetSupervisionRecordXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 */
export function GetSupervisionRecordXlsFileUrl(cid) {
  return `${this._url}/community/${cid}/supervision_record/export`;
}
